export default __webpack_public_path__ + "866908152cc91c696d7ee8cf915b5c6f.png";